import styled, { css } from 'styled-components';

export const FlagImageWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    margin: calc(100% / 8);
    background-color: ${theme.co.neutral60};
    border-radius: 100%;
  `,
);

export const FlagImage = styled.img(
  () => css`
    height: 100%;
    width: 100%;
  `,
);
